__webpack_require__.p = "https://christyuda.github.io/portofolio/";